// @flow

const convertBitToBoolean = (fieldValue: any): boolean => Number(fieldValue) > 0;

export default convertBitToBoolean;
